import { render, staticRenderFns } from "./BeePurple.vue?vue&type=template&id=3992c120&scoped=true&"
import script from "./BeePurple.vue?vue&type=script&lang=js&"
export * from "./BeePurple.vue?vue&type=script&lang=js&"
import style0 from "./BeePurple.vue?vue&type=style&index=0&id=3992c120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3992c120",
  null
  
)

export default component.exports